import { Typography } from '@mui/material';
import { getSemaforoColor, SemaforoColor } from '../utils/semaforo';

const SEMAFORO_TEXT_COLOR: Record<SemaforoColor, string> = {
    verde: '#2E7D32',
    amarillo: '#E65100',
    rojo: '#C62828',
    neutro: ''
};

interface ChipVencimientoSRTProps {
    fechaVencimientoSRT?: string | null;
    fechaPresentacionVisita?: string | null;
}

export default function ChipVencimientoSRT({
    fechaVencimientoSRT,
    fechaPresentacionVisita
}: ChipVencimientoSRTProps) {
    const color = getSemaforoColor(fechaVencimientoSRT, fechaPresentacionVisita);

    if (color === 'neutro' || !fechaVencimientoSRT) {
        return (
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.disabled' }}>
                -
            </Typography>
        );
    }

    const fechaFormateada = new Date(fechaVencimientoSRT).toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    });

    return (
        <Typography
            variant="body2"
            sx={{ fontWeight: 700, color: SEMAFORO_TEXT_COLOR[color], textAlign: 'center' }}
        >
            {fechaFormateada}
        </Typography>
    );
}
